import { render, staticRenderFns } from "./DocumentDisplay.vue?vue&type=template&id=df4c39f8&scoped=true"
import script from "./DocumentDisplay.vue?vue&type=script&lang=js"
export * from "./DocumentDisplay.vue?vue&type=script&lang=js"
import style0 from "./DocumentDisplay.vue?vue&type=style&index=0&id=df4c39f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4c39f8",
  null
  
)

export default component.exports